<template>
<div class="lottery">
    <!-- 简洁页眉 -->
    <div class="lottery-header"></div>

    <!-- 历史记录 -->
    <div class="history" v-if="active" @click.self="active = false">
        <div class="history-content">
            <div class="history-header">
                <h3>{{$t('Hi')}}</h3>
                <van-icon name="cross" class="close-icon" @click="active = false" />
            </div>
            <div class="history-body">
                <div class="left">
                    <p>{{$t('game.expect')}}</p>
                    <ul>
                        <li v-for="(v,key) in lottery_list" :key="key">{{v.expect}}</li>					
                    </ul>
                </div>
                <div class="right">
                    <p>{{$t('game.jieguo')}}</p>
                    <ul>
                        <li class="mak" v-for="(v,key) in lottery_list" :key="key">
                            <div class="ball">
                                <span :class="'idem' + v.opencode[0]">{{v.opencode[0]}}</span>
                                <span :class="'idem' + v.opencode[1]">{{v.opencode[1]}}</span>
                                <span :class="'idem' + v.opencode[2]">{{v.opencode[2]}}</span>
                            </div>
                            <div class="res">
                                <span>{{v.opencode[0] + v.opencode[1] + v.opencode[2]}}</span>
                                <span>{{getSizeText(v.opencode)}}</span>
                                <span>{{getDoubleText(v.opencode)}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!-- 顶部信息 -->
    <div class="top">
        <div class="qs">
            <div class="game-info">
                <div class="ico">
                    <img :src="showimage" alt="">
                </div>
                <div class="info-text">
                    <h1>{{lottery.next_expect}}</h1>
                    <span class="countdown">
                        <span class="countdown-label">{{$t('game.lefttime')}}:</span>
                        <van-count-down :time="time" @finish="check()" />
                    </span>
                </div>
            </div>
        </div>
        <div class="number">
            <div class="current-result">
                <div class="ball">
                    <p>
                        {{lottery.now_expect}}
                        <br>
                        {{$t('game.lunci')}}
                    </p>
                </div>
            </div>
            <div class="result-display">
                <div class="res">
                    <span class="result-item sum">{{sum}}</span>
                    <span class="result-item size">{{size}}</span>
                    <span class="result-item double">{{double}}</span>
                </div>
                <van-icon name="arrow-down" :class="{ up: active, down: !active }" @click="toggleHistory" />
            </div>
        </div>
    </div>

    <!-- 投注区域 -->
    <div class="lottery-content">
        <div class="betting-area">
            <div class="betting-options" id="toBottom">
                <div class="options-grid">
                    <div class="option-item" 
                        :class="{active: choose[v.type]}" 
                        v-for="(v,key) in lottery_peilv_list" 
                        :key="key" 
                        @click="choosePlay(v.type, v.name)">
                        <p>{{$t('game.'+v.name)}}</p>
                        <span class="odds">({{v.proportion}})</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 投注面板 -->
    <div class="betting-panel" v-if="shopping">
      <div class="panel-content">
        <div class="info-row">
          <div class="info-item">
            <label>{{$t('quantity')}}</label>
            <input type="number" v-model.number="money" placeholder="0">
          </div>
          
          <div class="info-item">
            <label>{{$t('total')}}</label>
            <span class="amount">{{formData.length * money}}</span>
          </div>
          
          <div class="info-item">
            <label>{{$t('ticketAmount')}}</label>
            <span class="ticket-count">{{formData.length}}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 游戏切换弹窗 -->
    <van-popup v-model="showRight" position="right" :style="{ width: '65%', height: '100%' }">
        <div class="game-switch-popup">
            <div class="game-item" @click="toLottery(v.key, v.id)" v-for="(v,key) in game_type_list" :key="key">
                <p>{{v.name}}</p>
            </div>
        </div>
    </van-popup>
    
    <!-- 确认订单弹窗 -->
    <van-popup v-model="jiesuanpage" get-container="body">
      <div class="confirm-order-modal">
          <div class="head van-hairline--bottom">
            <p class="text">{{$t('game.order')}}</p>
          </div>
          <ul class="order-list">
              <li v-for="(v,key) in formData" :key="key" class="list-item van-hairline--bottom">
                  <div class="main">
                    <p class="bet-name">{{$t('game.'+v.name)}}</p>
                    <p class="detail-text">1X{{ money }}={{ money }}</p>
                  </div>
                  <van-icon @click="clearChooes(v.type)" name="close" />
              </li>
          </ul>
          <div class="sub-bar">
            <van-button class="item cancel-btn" type="default" @click="allClear">{{$t('game.clear')}}</van-button>
            <van-button class="item sub-btn" type="default" @click="doSub">{{$t('game.submit')}}</van-button>
          </div>
      </div>
    </van-popup>
    
    <!-- 底部操作栏 -->
    <div class="footer">
        <div class="balance-info">
            <p>
                {{$t('availablePoints')}}
                <span class="balance">{{ userInfo.money }}</span>
            </p>
        </div>
        <button class="confirm-btn" @click="jiesuan">
            {{$t('verify')}}
        </button>
    </div>
</div>
</template>

<script>
var time;
var count = 0;

export default {
	props: ["pkey", "pid",'ppic'],
  data() {
    return {
      jiesuanpage:false,
      choose: {
        "大":false,
        "小":false,
        "单":false,
        "双":false,
        "3":false,
        "4":false,
        "5":false,
        "6":false,
        "7":false,
        "8":false,
        "9":false,
        "10":false,
        "11":false,
        "12":false,
        "13":false,
        "14":false,
        "15":false,
        "16":false,
        "17":false,
        "18":false,
      },
      playgame:false,
      shopping:false,
      isLoading: false,
      showRight: false,
	  game_type_list: [{},{},{},{}],
	  showimage:'',
	  title:'',
	  key:'',
	  id:'',
      play:{},
      lottery_peilv_list:{},
      lottery_list:{},
      active: false,
      userInfo:{},
      lottery:{},
      shanzi_1:"0",
      shanzi_2:"0",
      shanzi_3:"0",
      sum:0,
      size:"",
      double:"",
      time:0,
      shopchoose:"未选择",
      gameitem:"",
      formData:[],
      money:0,
    };
  },
  mounted() {
	this.key = this.pkey;
	this.id = this.pid;
	this.showimage = this.ppic;
  },
  methods: {
    back(){
      return window.history.back();
    },
    
    getSizeText(opencode) {
      const sum = opencode[0] + opencode[1] + opencode[2];
      return sum >= 11 && sum <= 18 ? this.$t('game.da') : this.$t('game.xiao');
    },
    
    getDoubleText(opencode) {
      const sum = opencode[0] + opencode[1] + opencode[2];
      return sum % 2 === 0 ? this.$t('game.shuang') : this.$t('game.dan');
    },
    
    toggleHistory() {
      this.active = !this.active;
    },
    
	toLottery(key,id){
	  if(!localStorage.getItem('token')){
	    this.$router.push({path:'/Home'})
	  }else {
	    this.$router.push({path:'/Lottery?key='+key+"&id="+id})
	  }
	},
    
    doSub(){
      if(this.money === 0){
        this.$toast(this.$t('game.plsmoney'));
        return false;
      }
      if(this.formData.length === 0){
        this.$toast(this.$t('game.plsnum'));
        return false;
      } else {
        if(this.userInfo.money - (this.money * this.formData.length) < 0 ){
          this.$toast(this.$t('game.moneynote'));
          return false;
        }else {
          this.$http({
            method: 'post',
            data:{
               item:this.gameitem,
               money:this.money,
               lid:this.lottery.id,
               mid:this.userInfo.id,
               expect:this.lottery.now_expect
            },
            url: 'game_place_order'
          }).then(res=>{
            if(res.code === 200){
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            }else if(res.code === 401){
              this.$toast(res.msg);
            }
          })
          return true;
        }
      }
    },
    
    allClear(){
      for(let i = 0; i < this.formData.length; i++){
          this.choose[this.formData[i]['type']] = false;
      }
      this.formData = [];
      this.money = 0;
      this.shopchoose = "未选中";
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    
    jiesuan(){
      if(this.formData.length === 0){
        this.$toast(this.$t('game.plsnum'));
        return false;
      }else if(this.money === 0){
        this.$toast(this.$t('game.plsmoney'));
        return false;
      }
      else {
        this.doSub();
      }
    },
    
    clearChooes(type){
      this.formData = this.formData.filter(item => item.type !== type);
      this.choose[type] = false;
      
      if(this.formData.length >= 1){
        this.shopchoose = this.formData.map(item => this.$t("game." + item.name)).join(",");
        this.gameitem = this.formData.map(item => item.type).join(",");
      }else {
        this.shopchoose = "未选中";
        this.gameitem = "";
        this.shopping = false;
      }
      if(this.formData.length === 0){
        this.jiesuanpage = false;
      }
    },
    
    choosePlay(type,name){
        if(this.choose[type]){
          this.choose[type] = false;
          this.formData = this.formData.filter(item => item.type !== type);
        }else {
          this.formData.push({'name': name, 'type': type});
          this.choose[type] = true;
        }
        
        this.shopping = this.formData.length >= 1;
        if(this.formData.length >= 1){
          this.shopchoose = this.formData.map(item => this.$t("game." + item.name)).join(",");
          this.gameitem = this.formData.map(item => item.type).join(",");
        }else {
          this.shopchoose = "未选中";
          this.gameitem = "";
        }
    },

    check(){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Home'})
      }else {
        time = window.setInterval(() => {
          setTimeout(()=>{
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if(count > 5){
              clearInterval(time);
              count = 0;
            }
          },0)
        }, 300)
      }
    },
    
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('common.refresh'));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    
    getLotteryPeilv(){
      this.$http({
        method: 'get',
        data:{id:this.id},
        url: 'lottery_get_peilv'
      }).then(res=>{
        if(res.code === 200){
          this.lottery_peilv_list = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    
	getGameItem(){
	  this.$http({
	    method: 'get',
	    url: 'lottery_hot'
	  }).then(res=>{
	    this.game_type_list = res.data
	  })
	},
    
    getLotteryList(){
      this.$http({
        method: 'get',
        data:{key:this.key},
        url: 'lottery_get_one_list'
      }).then(res=>{
        if(res.code === 200){
          this.lottery_list = res.data;
          this.getLotteryPeilv();
        }else if(res.code ===401){
          // this.$toast(res.msg);
        }
      })
    },
    
    getLotteryInfo(){
      this.$http({
        method: 'get',
        data:{key:this.key},
        url: 'lottery_get_info'
      }).then(res=>{
        if(res.code === 200){
          if(parseFloat(this.userInfo.money) < parseFloat(res.data.condition)){
            this.$toast(this.$t('game.lxgly'));
            this.$router.push({path:'/Home'})
            return false;
          }
          this.lottery = res.data;

		  if(this.showimage==''||this.showimage== undefined){
			  this.showimage = res.data.ico;
		  }
		  
          this.time = res.data.second * 1000;

          if(this.time/1000 === 59){
            this.$toast(this.$t('game.kjcc')+this.lottery.now_expect);
          }
          
          this.sum = res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
          if(this.sum >= 11 && this.sum <=18){
            this.size = this.$t('game.da');
          }else if(this.sum >= 3 && this.sum <= 10){
            this.size = this.$t('game.xiao');
          }
          if(this.sum % 2 === 0){
            this.double = this.$t('game.shuang');
          }else {
            this.double = this.$t('game.dan');
          }
        }else if(res.code ===401){
          // this.$toast(res.msg);
        }
      })
    }
  },
  
  created() {
	  this.showimage = this.$route.query.logo_pic;
	  this.title = this.$route.query.title;
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Home'})
    }else {
        this.getUserInfo();
        this.getLotteryInfo();
        this.getLotteryList();
		this.getGameItem();
    }
  },
  
  destroyed() {
    clearInterval(time);
  }
};
</script>

<style lang='less' scoped>
.lottery {
    width: 100%;
    min-height: 100vh;
    /* 紫蓝渐变背景 */
    background: linear-gradient(135deg, #8e44ad 0%, #3498db 100%);
    position: relative;
}

/* 简洁页眉 */
/* 简洁页眉 */
.lottery-header {
    height: 44px;
    background: linear-gradient(135deg, rgba(52, 152, 219, 0.9), rgba(142, 68, 173, 0.8));
    backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 2px 10px rgba(142, 68, 173, 0.3);
}

/* 顶部信息区域 - 紫蓝主题 */
.top {
    padding: 1rem 1rem 0.8rem;
    background: linear-gradient(135deg, rgba(142, 68, 173, 0.9), rgba(52, 152, 219, 0.8));
    backdrop-filter: blur(10px);
    margin: 0.5rem;
    border-radius: 16px;
}

.game-info {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
}

.ico {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 12px;
    overflow: hidden;
    background: rgba(255,255,255,0.2);
    padding: 0.3rem;
}

.ico img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
}

.info-text {
    flex: 1;
    margin-left: 1rem;
}

.info-text h1 {
    font-size: 1.2rem;
    color: #fff;
    font-weight: 700;
    margin-bottom: 0.3rem;
    text-shadow: 1px 1px 3px rgba(0,0,0,0.2);
}

.countdown {
    display: flex;
    align-items: center;
    font-size: 0.85rem;
    color: #fff;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
}

.countdown-label {
    margin-right: 0.5rem;
}

/* 倒计时时间数字样式 - 紫蓝主题 */
.countdown .van-count-down {
    font-size: 1.2rem;
    color: #ffd54f;
    font-weight: bold;
    margin-left: 0.3rem;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.2);
}

/* 当前结果区域 - 紫蓝主题 */
.number {
    display: flex;
    background: rgba(255,255,255,0.95);
    border-radius: 16px;
    padding: 1rem;
    box-shadow: 0 4px 15px rgba(142, 68, 173, 0.2);
}

.current-result {
    flex: 1;
    display: flex;
    align-items: center;
}

.current-result .ball p {
    font-size: 0.9rem;
    color: #000000;
    font-weight: 600;
    line-height: 1.4;
}

.result-display {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
}

.res {
    display: flex;
    gap: 0.5rem;
}

.result-item {
    width: 2.2rem;
    height: 2.2rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    font-weight: 600;
    color: #fff;
    /* 紫蓝渐变 */
    background: linear-gradient(135deg, #9b59b6, #3498db);
    box-shadow: 0 2px 8px rgba(142, 68, 173, 0.4);
}

/* 投注区域 - 紫蓝主题 */
.lottery-content {
    flex: 1;
    padding: 1rem;
}

.betting-area {
    background: rgba(255,255,255,0.95);
    border-radius: 20px;
    margin: 0.5rem;
    box-shadow: 0 4px 20px rgba(142, 68, 173, 0.15);
    overflow: hidden;
}

.betting-options {
    max-height: 50vh;
    overflow-y: auto;
}

.options-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.8rem;
    padding: 1rem;
}

/* 投注选项 - 紫蓝主题 */
.option-item {
    background: #fff;
    border: 2px solid #a29bfe;
    border-radius: 16px;
    padding: 1.2rem 0.8rem;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(142, 68, 173, 0.2);
}

.option-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(142, 68, 173, 0.3);
}

.option-item.active {
    /* 紫蓝激活状态 */
    background: linear-gradient(135deg, #9b59b6, #3498db);
    border-color: #8e44ad;
    color: #fff;
}

.option-item p {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 0.3rem;
    color: inherit;
}

.odds {
    font-size: 0.8rem;
    opacity: 0.8;
}

/* 投注面板 - 紫蓝主题 */
.betting-panel {
  position: fixed;
  bottom: 4rem;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 -4px 20px rgba(142, 68, 173, 0.2);
  z-index: 1000;
}

.panel-content {
  padding: 1.2rem 1.5rem;
}

/* 三列信息行 */
.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
}

.info-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  text-align: center;
}

.info-item label {
  font-size: 0.85rem;
  color: #000000;
  font-weight: 500;
  margin-bottom: 0.5rem;
  white-space: nowrap;
}

.info-item input {
  border: 2px solid #000000;
  border-radius: 8px;
  padding: 0.6rem;
  font-size: 1rem;
  text-align: center;
  width: 100%;
  background: #f8f9ff;
  color: #000000;
}

.info-item input:focus {
  border-color: #000000;
  outline: none;
}

.amount {
  font-size: 1.2rem;
  font-weight: 700;
  color: #000000;
  padding: 0.5rem 0;
}

.ticket-count {
  font-size: 1.2rem;
  font-weight: 700;
  color: #000000;
  background: #f8f9ff;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  border: 1px solid #e0e7ff;
}

/* 响应式调整 */
@media (max-width: 480px) {
  .panel-content {
    padding: 1rem;
  }
  
  .info-row {
    gap: 0.5rem;
  }
  
  .info-item label {
    font-size: 0.8rem;
  }
  
  .info-item input {
    padding: 0.5rem;
    font-size: 0.9rem;
  }
  
  .amount, .ticket-count {
    font-size: 1rem;
  }
}

/* 底部操作栏 - 紫蓝主题 */
.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.5rem;
    box-shadow: 0 -2px 10px rgba(142, 68, 173, 0.1);
    z-index: 1001;
    border-radius: 20px 20px 0 0;
}

.balance-info p {
    font-size: 0.9rem;
    color: #8e44ad;
}

.balance {
    color: #8e44ad;
    font-weight: 700;
    margin-left: 0.3rem;
}

.confirm-btn {
    /* 紫蓝按钮 */
    background: linear-gradient(135deg, #9b59b6, #3498db);
    color: #fff;
    border: none;
    border-radius: 25px;
    padding: 0.8rem 2rem;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 4px 15px rgba(142, 68, 173, 0.4);
    transition: all 0.3s ease;
}

.confirm-btn:active {
    transform: scale(0.98);
    box-shadow: 0 2px 8px rgba(142, 68, 173, 0.5);
}

/* 历史记录 - 紫蓝主题 */
.history {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(142, 68, 173, 0.1);
    z-index: 2000;
    display: flex;
    align-items: flex-end;
}

.history-content {
    background: #fff;
    border-radius: 24px 24px 0 0;
    width: 100%;
    max-height: 80vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.history-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.2rem 1.5rem;
    border-bottom: 1px solid #e0e7ff;
    background: linear-gradient(135deg, #f8f9ff, #e0e7ff);
    border-radius: 24px 24px 0 0;
}

.history-header h3 {
    font-size: 1.1rem;
    color: #8e44ad;
    font-weight: 600;
    margin: 0;
}

/* 放大关闭键 */
.close-icon {
    font-size: 2rem;
    color: #8e44ad;
    cursor: pointer;
    padding: 0.5rem;
    transition: all 0.3s ease;
}

.close-icon:active {
    background: #e0e7ff;
    border-radius: 50%;
    transform: scale(0.9);
}

.history-body {
    display: flex;
    flex: 1;
    overflow: hidden;
}

.history-body .left,
.history-body .right {
    flex: 1;
    padding: 1rem;
    overflow-y: auto;
}

.history-body .left {
    background: #f8f9ff;
    border-right: 1px solid #e0e7ff;
}

.history-body p {
    font-size: 0.9rem;
    font-weight: 600;
    color: #8e44ad;
    margin-bottom: 1rem;
    position: sticky;
    top: 0;
    background: inherit;
    padding: 0.5rem 0;
}

.history-body ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.history-body li {
    padding: 0.8rem 0;
    border-bottom: 1px solid #e0e7ff;
    text-align: center;
    font-size: 0.85rem;
    color: #8e44ad;
}

/* CSS骰子样式 - 紫蓝主题 */
.idem1, .idem2, .idem3, .idem4, .idem5, .idem6 {
    width: 2.2rem;
    height: 2.2rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 0.3rem;
    /* 紫蓝骰子 */
    background: linear-gradient(145deg, #9b59b6, #3498db);
    border: 2px solid #8e44ad;
    border-radius: 12px;
    font-weight: 800;
    color: white;
    font-size: 1.2rem;
    box-shadow: 0 4px 8px rgba(142, 68, 173, 0.4);
    text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
}

/* 不同点数的颜色变化 - 紫蓝色系 */
.idem1 { background: linear-gradient(145deg, #9b59b6, #8e44ad); }
.idem2 { background: linear-gradient(145deg, #8e44ad, #9b59b6); }
.idem3 { background: linear-gradient(145deg, #3498db, #2980b9); }
.idem4 { background: linear-gradient(145deg, #2980b9, #3498db); }
.idem5 { background: linear-gradient(145deg, #a29bfe, #6c5ce7); }
.idem6 { background: linear-gradient(145deg, #6c5ce7, #a29bfe); }

/* 游戏切换弹窗 - 紫蓝主题 */
.game-switch-popup {
    padding: 1rem;
    background: linear-gradient(135deg, #f8f9ff, #e0e7ff);
}

.game-item {
    background: #fff;
    border-radius: 16px;
    padding: 1.2rem;
    margin-bottom: 0.8rem;
    text-align: center;
    box-shadow: 0 2px 8px rgba(142, 68, 173, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid #e0e7ff;
}

.game-item:active {
    background: #f8f9ff;
    transform: scale(0.98);
}

.game-item p {
    font-size: 1rem;
    font-weight: 600;
    color: #8e44ad;
    margin: 0;
}

/* 确认订单弹窗 - 紫蓝主题 */
.confirm-order-modal {
    background: #fff;
    border-radius: 20px;
    padding: 1.5rem;
    max-width: 90vw;
    max-height: 70vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border: 2px solid #e0e7ff;
}

.confirm-order-modal .head {
    text-align: center;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid #e0e7ff;
}

.confirm-order-modal .text {
    font-size: 1.2rem;
    font-weight: 700;
    color: #8e44ad;
    margin: 0;
}

.order-list {
    flex: 1;
    overflow-y: auto;
    margin-bottom: 1.5rem;
}

.list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 0;
    border-bottom: 1px solid #e0e7ff;
}

.bet-name {
    font-size: 1rem;
    font-weight: 600;
    color: #8e44ad;
    margin: 0 0 0.3rem 0;
}

.detail-text {
    font-size: 0.9rem;
    color: #8e44ad;
    margin: 0;
}

.sub-bar {
    display: flex;
    gap: 1rem;
}

.sub-bar .item {
    flex: 1;
    border-radius: 25px;
    padding: 0.8rem;
    font-size: 1rem;
    font-weight: 600;
    border: none;
}

.cancel-btn {
    background: #f8f9ff;
    color: #8e44ad;
    border: 2px solid #a29bfe;
}

.sub-btn {
    background: linear-gradient(135deg, #9b59b6, #3498db);
    color: #fff;
    box-shadow: 0 4px 15px rgba(142, 68, 173, 0.4);
}

/* 响应式调整 */
@media (max-width: 375px) {
    .options-grid {
        grid-template-columns: 1fr;
        gap: 0.6rem;
    }
    
    .result-item {
        width: 1.8rem;
        height: 1.8rem;
        font-size: 0.7rem;
    }
    
    .footer {
        padding: 0.8rem 1rem;
    }
    
    .confirm-btn {
        padding: 0.7rem 1.5rem;
        font-size: 0.9rem;
    }
    
    /* 小屏幕骰子调整 */
    .idem1, .idem2, .idem3, .idem4, .idem5, .idem6 {
        width: 1.8rem;
        height: 1.8rem;
        font-size: 1rem;
        margin: 0 0.2rem;
    }
}

/* 动画效果 */
.down {
  transition: all 0.3s ease;
}

.up{
  transform: rotate(180deg);
  transition: all 0.3s ease;
}

.van-icon {
  font-size: 1.2rem;
}

/* 滚动条样式 - 紫蓝主题 */
.betting-options::-webkit-scrollbar {
    width: 4px;
}

.betting-options::-webkit-scrollbar-track {
    background: #e0e7ff;
    border-radius: 2px;
}

.betting-options::-webkit-scrollbar-thumb {
    background: #9b59b6;
    border-radius: 2px;
}

.betting-options::-webkit-scrollbar-thumb:hover {
    background: #8e44ad;
}
</style>